import React from 'react';
import { Box, Typography, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { budgetDateKey, getBudgetHistory, getNextBudgetChange } from '../../utils/budgetAmounts';

const money = amount => '$' + Number(amount).toLocaleString('en-NZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const dateLabel = date => new Date(`${date}T00:00:00`).toLocaleDateString('en-NZ', { day: 'numeric', month: 'short', year: 'numeric' });

export function ScheduledBudgetAmount({ budget }) {
  const next = getNextBudgetChange(budget);
  return next ? <Typography component="span" display="block" variant="caption" color="text.secondary">
    {money(next.amount)} from {dateLabel(next.effectiveFrom)}
  </Typography> : null;
}

export default function BudgetAmountHistory({ budget }) {
  if (!budget) return null;
  const history = getBudgetHistory(budget);
  const today = budgetDateKey();
  const current = history.filter(v => v.effectiveFrom <= today).slice(-1)[0];
  return <Box component="details" sx={{ mt: 2 }}>
    <Typography component="summary" variant="body2" sx={{ cursor: 'pointer', fontWeight: 600 }}>
      Amount history &amp; scheduled changes ({history.length})
    </Typography>
    <Table size="small" aria-label="Budget amount history">
      <TableHead><TableRow><TableCell>Applies from</TableCell><TableCell align="right">Amount</TableCell><TableCell>Status</TableCell></TableRow></TableHead>
      <TableBody>{history.map(v => <TableRow key={v.effectiveFrom}>
        <TableCell>{dateLabel(v.effectiveFrom)}</TableCell>
        <TableCell align="right">{money(v.amount)}</TableCell>
        <TableCell>{v.effectiveFrom > today ? 'Scheduled' : v === current ? 'Current' : 'Previous'}</TableCell>
      </TableRow>)}</TableBody>
    </Table>
  </Box>;
}
